import { render } from "./PendingApprovalHygiene.vue?vue&type=template&id=8a91f184&scoped=true"
import script from "./PendingApprovalHygiene.vue?vue&type=script&lang=js"
export * from "./PendingApprovalHygiene.vue?vue&type=script&lang=js"

import "./PendingApprovalHygiene.vue?vue&type=style&index=0&id=8a91f184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a91f184"]])

export default __exports__